import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const FlameBikerJacket = () => {
  const {
    itemName,
    itemPrice,
    itemFabric,
    sizeChart,
    shopifyDivId,
    shopifyId,
    pictures,
  } = AW23.jackets.FlameBikerJacket;
  const { imgWidth, imgHeight, loading } = AW23;

  const renderPictures = () => {
    return pictures.map(({ srcJpeg }) => (
      <SwiperSlide>
        <img
          src={srcJpeg}
          alt={itemName}
          width={imgWidth}
          height={imgHeight}
          loading={loading}
        />
      </SwiperSlide>
    ));
  };

  return (
    <ProductsContainer
      pageTitle={itemName}
      name={itemName}
      price={itemPrice}
      fabric={itemFabric}
      src={sizeChart}
      divId={shopifyDivId}
      mainId={shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(renderPictures())}
    </ProductsContainer>
  );
};

export default FlameBikerJacket;
